import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\CheckDeposit\GetCheckDepositListController::__invoke
* @see app/Http/Controllers/CheckDeposit/GetCheckDepositListController.php
* @route '/api/fetch-check-deposit'
*/
const GetCheckDepositListController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetCheckDepositListController.url(options),
    method: 'get',
})

GetCheckDepositListController.definition = {
    methods: ["get","head"],
    url: '/api/fetch-check-deposit',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\CheckDeposit\GetCheckDepositListController::__invoke
* @see app/Http/Controllers/CheckDeposit/GetCheckDepositListController.php
* @route '/api/fetch-check-deposit'
*/
GetCheckDepositListController.url = (options?: RouteQueryOptions) => {
    return GetCheckDepositListController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\CheckDeposit\GetCheckDepositListController::__invoke
* @see app/Http/Controllers/CheckDeposit/GetCheckDepositListController.php
* @route '/api/fetch-check-deposit'
*/
GetCheckDepositListController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetCheckDepositListController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\CheckDeposit\GetCheckDepositListController::__invoke
* @see app/Http/Controllers/CheckDeposit/GetCheckDepositListController.php
* @route '/api/fetch-check-deposit'
*/
GetCheckDepositListController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetCheckDepositListController.url(options),
    method: 'head',
})

export default GetCheckDepositListController